// src/components/ProductManagement/ProductTable.js
import React from "react";
import PaginationComponent from "../../../components/Pagination/PaginationComponent";
import SelectSingleComponent from "../../../components/SelectSingleComponent/SelectSingleComponent";
import { IconEdit, IconFile, IconTrash } from "../../../assets/icons";
import { toast } from "react-toastify";
import { ProductService } from "../../../services/productService";
import { useNavigate } from "react-router-dom";

const ProductTable = ({
  products,
  columns,
  onPageChange,
  totalRecord,
  currentPage,
  onPageSizeChange,
  pageSize,
  refetchData,
  setEditingProduct,
  setIsModalVisible,
  selectedProducts,
  setSelectedProducts,
}) => {
  const navigate = useNavigate();

  const handleDelete = async (productId) => {
    try {
      const confirmDelete = window.confirm(
        "Bạn có chắc chắn muốn xóa sản phẩm này?"
      );
      if (!confirmDelete) return;

      const response = await ProductService.deleteProduct(productId);
      if (response.Status === 200) {
        toast.success("Sản phẩm đã được xóa thành công!");
        // Gọi lại API để cập nhật danh sách sản phẩm
        onPageChange?.(currentPage);
        refetchData?.();
      } else {
        toast.error("Xóa sản phẩm thất bại!");
      }
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.error("Có lỗi xảy ra khi xóa sản phẩm!");
    }
  };

  const handleEdit = async (productSlug) => {
    try {
      const response = await ProductService.getProductDetail(productSlug);
      if (!response.Data) {
        toast.error("Có lỗi khi cập nhật sản phẩm!");
        return;
      }
      setEditingProduct(response.Data); // Truyền vào form
      setIsModalVisible(true); // Hiển thị form
    } catch (error) {
      toast.error("Có lỗi khi cập nhật sản phẩm!");
      console.error(error);
    }
  };

  const renderTableHeaders = () => {
    return columns.map(
      (column) =>
        column.isDisplay && <th key={column.key}>{column.displayName}</th>
    );
  };

  const renderTableRows = () => {
    return products.map((product, index) => (
      <tr key={product.id}>
        <td className="w-16">
          <input
            type="checkbox"
            className="cursor-pointer"
            checked={selectedProducts.includes(product.id)}
            onChange={() => handleCheckboxChange(product.id)}
          />
        </td>
        <td>{(currentPage - 1) * pageSize + index + 1}</td>
        {columns.map((column) =>
          column.isDisplay ? (
            <td key={column.key} className={column.key === "images" && "w-36"}>
              {column.key === "images" && product[column.key].length > 0 ? (
                <img
                  src={product[column.key].map((image) => image?.src)[0]}
                  alt={product.name || "Product Image"}
                  className="w-16 h-16 object-cover rounded-md"
                />
              ) : (
                product[column.key]
              )}
            </td>
          ) : null
        )}
        <td>
          <div className="flex gap-2">
            <button
              className="bg-primaryColor rounded-md p-1"
              onClick={() => handleEdit(product.slug)}
              data-tooltip={"Chỉnh sửa"}
            >
              <IconEdit className="stroke-white w-6 h-6" />
            </button>
            <button
              className="bg-red-500 rounded-md p-1"
              onClick={() => handleDelete(product.id)}
              data-tooltip={"Xoá"}
            >
              <IconTrash className="stroke-white w-6 h-6" />
            </button>
            <button
              className="bg-green-500 rounded-md p-1"
              onClick={() =>
                navigate(`/products/${product.category}/${product.slug}`)
              }
              data-tooltip={"Xem trang sản phẩm"}
            >
              <IconFile className="stroke-white w-6 h-6" />
            </button>
          </div>
        </td>
      </tr>
    ));
  };

  const handleCheckboxChange = (productId) => {
    setSelectedProducts(
      (prev) =>
        prev.includes(productId)
          ? prev.filter((id) => id !== productId) // Bỏ khỏi danh sách nếu đã chọn
          : [...prev, productId] // Thêm vào danh sách nếu chưa chọn
    );
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedProducts(products.map((product) => product.id)); // Chọn tất cả
    } else {
      setSelectedProducts([]); // Bỏ chọn tất cả
    }
  };

  return (
    <div>
      <table>
        <thead>
          <tr>
            <th className="w-16 text-center">
              <input
                type="checkbox"
                className="cursor-pointer"
                onChange={(e) => handleSelectAll(e.target.checked)}
                checked={
                  selectedProducts.length > 0 &&
                  selectedProducts.length === products.length
                }
              />
            </th>
            <th className="w-16">STT</th>
            {renderTableHeaders()}
            <th className="w-32">Hành động</th>
          </tr>
        </thead>
        <tbody>{renderTableRows()}</tbody>
      </table>
      <div className="flex justify-between">
        <div className="flex gap-2 items-center">
          <span>Số dòng mỗi trang:</span>
          <SelectSingleComponent
            options={[
              { value: 10, label: 10 },
              { value: 20, label: 20 },
              { value: 50, label: 50 },
            ]}
            onChange={() => onPageSizeChange?.()}
            selectedOption={pageSize}
          />
        </div>
        {/* {renderPagination()} */}
        <PaginationComponent
          currentPage={currentPage}
          pageSize={pageSize}
          total={totalRecord}
          onChange={(page) => onPageChange?.(page)}
        />
      </div>
    </div>
  );
};

export default ProductTable;
